import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AuthCode from "../../types/auth-code";
import { ActiveTab } from "./active-tab";
import Alert from "./alert";

interface IResetTabProps {
  alert: boolean;
  username: string;
  password: string;
  setPassword: (password: string) => void;
  setActiveTab: (activeTab: ActiveTab) => void;
  handleContinue: (e: AuthCode) => void;
}

const ResetTab: React.FunctionComponent<IResetTabProps> = ({
  alert,
  username,
  password,
  setPassword,
  setActiveTab,
  handleContinue,
}) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AuthCode>();

  return (
    <>
      <div className="signup-form-head-section mb-2 flex-col flex">
        <span className="sepanta-icon-mobile icon-box"></span>
        <h3 className="head-title pt-4">{t("ResetPassword.Title")}</h3>
      </div>
      {alert && <Alert color="red" message={t("ResetPassword.Error")} />}
      <form onSubmit={handleSubmit(handleContinue)}>
        <input
          maxLength={12}
          {...register("username")}
          type="hidden"
          value={username}
          className="form-control form-control-lg pl-4 shadow-none"
        />

        <div className="form-section rtl flex flex-grow flex-col gap-4 mb-0">
          <div className="form-group flex flex-col w-full rtl text-center  mt-2 relative">
            <label htmlFor="" className="pr-4 mb-10">
              {t("ResetPassword.Desc")}
            </label>
            <input
              {...register("code")}
              type="password"
              className="border-2 p-4 rounded-lg mt-2 text-center verify-code-input"
              placeholder={t(`ResetPassword.Code`)}
            />
            <p className="absolute left-0 right-0 top-8 text-red-500">
              {errors.code?.message}
            </p>
          </div>
        </div>

        <div className="form-section rtl flex flex-col mt-6 gap-4 justify-between pb-10">
          <button className="verify-account-btn p-5 flex text-center justify-center">
            {t("ResetPassword.Continue")}
            <span className="sepanta-icon-left-long-arrow"></span>
          </button>

          <button
            onClick={() => setActiveTab("forgot")}
            className="flex items-center justify-center navigate-link-bd"
          >
            {t("ResetPassword.Resend")}
          </button>
        </div>
      </form>
    </>
  );
};

export default ResetTab;
